module.exports = __webpack_public_path__ + "media/images/lp_chintai/sp_main-e6dacfb80df037fbb3caf1f3b3574c2d.png";